/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Error_Members_RequiredInputs */



/**
* | output |
* | --- |
* | "Share must include at least one team member." |
*
* @param {Team_Share_Error_Members_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_error_members_required = /** @type {((inputs?: Team_Share_Error_Members_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Error_Members_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le partage doit inclure au moins un membre de l’équipe.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Beitrag muss mindestens ein Teammitglied enthalten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La quota deve includere almeno un membro del team.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В состав команды должен входить как минимум один участник.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La acción debe incluir al menos un miembro del equipo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享者必须至少包含一名团队成员。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有には少なくとも 1 人のチーム メンバーを含める必要があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर में कम से कम एक टीम सदस्य शामिल होना चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O compartilhamento deve incluir pelo menos um membro da equipe.")
	return /** @type {LocalizedString} */ ("Share must include at least one team member.")
});